/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SendLinkAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SendLinkAction({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Unscheduled/More/Content/ScheduleViaSmsOrEmail/Content/SendLinkAction",
  onSubmit,
  isSubmitting
  
}) {
let scheduleViaSubmitData = fromData.useDataSubmit({ viewPath,
context: 'schedule_via',
})
let scheduleViaIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'schedule_via',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="schedule_via"
 onClick={scheduleViaSubmitData}
 isDisabled={scheduleViaIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Send"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}